/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-08-31 16:33:17
 * @LastEditTime: 2022-09-26 15:45:52
 * @FilePath: /insurforce-backstage-platform-side/src/views/reportForm/task/utils.js
 */
const columns = [{
  slots: {
    title: '任务类型'
  },
  dataIndex: 'taskType',
  key: 'taskType',
  align: 'center',
  scopedSlots: {
    customRender: 'taskType'
  }
}, {
  slots: {
    title: '表单类型'
  },
  dataIndex: 'dataType',
  key: 'dataType',
  align: 'center',
  scopedSlots: {
    customRender: 'dataType'
  }
}, {
  slots: {
    title: '任务名称'
  },
  dataIndex: 'taskName',
  key: 'taskName',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  }
}, {
  slots: {
    title: '开始时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center'
}, {
  slots: {
    title: '结束时间'
  },
  dataIndex: 'finishAt',
  key: 'finishAt',
  align: 'center'
}, {
  slots: {
    title: '备注'
  },
  dataIndex: 'taskMsg',
  key: 'taskMsg',
  width: 350,
  align: 'center',
  scopedSlots: {
    customRender: 'taskMsg'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
export { pagination, columns };